import { all } from 'ramda';
import { validateFilterHasValues } from './validateFilterHasValues';
import { FilterList } from '@common/filter/types';

/**
 * Validate that a list of filters has values
 */
const validateFilters = (filters: FilterList['filters']): boolean =>
  Boolean(filters && filters.length && all(validateFilterHasValues, filters));

export default validateFilters;
